
import { Form, Icon, Input, Button, Checkbox, Row, Col, DatePicker, Divider, Radio, Collapse, Select, Modal } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';
import { Redirect, RouteProps, RouteComponentProps, NavLink, withRouter } from 'react-router-dom';
import AuthContext from '../../../Context/AuthContext';
import FormControl from '../../Forms/FormControl';
import { StyleGuestRegisterForm } from './GuestRegisterForm.Style';
import { GuestRegisterFormHandler } from './GuestRegisterFormHandler';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import { singleColFormColSize } from 'components/Forms/Form.Styled';
import ValidationUtility from 'Core/ValidationUtility';
import MaskedInput from 'components/Forms/MaskedInput';
import moment from 'moment';
import { RightAlignedRow } from 'components/Styled/Layout/RightAlignedRow';
import NotificationService from 'Core/NotificationService';
import ISelectOption from '../../Forms/SimpleSelect/ISelectOption';
import SimpleSelect from '../../Forms/SimpleSelect';
import styles from './RegistrationStyles.module.css';
import { MainLogo } from '../../Layout/RegisterLayout/RegisterLayout.Style';

import DetailsData from 'Core/models/DetailsData';
import DetailsMode from 'Core/models/DetailsMode';

import TcDoc from '../../../assets/Files/VMWM_IPO_General_Terms_and_Conditions.pdf';
import PrivacyDoc from '../../../assets/Files/VMWM_IPO_System_Data_Protection_Privacy_Policy.pdf';
import NumberFormat from 'react-number-format';


const { Option } = Select;
const { Panel } = Collapse;

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    registered: boolean;
    isCompany: boolean;
    isBrokerVM: boolean;
    showOTPModal: boolean;
    isIndividual: boolean;
    showResendBtn: boolean;
    disableResendBtn: boolean;
    otp: string;
    //questions: ISelectOption[];
    brokers: any;
    dobMode: "decade" | "time" | "year" | "month" | "date" | undefined;
    offeringId?: string;
    sharepoolId?: string;
    guestId?: string;
    showResumeModal: boolean;
    isResumeMode: boolean;
    resumeEmail?: string;
    resumeId?: number;
    applicationId?: string;
}

export class GuestRegisterFormWithoutFormAndRouter extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    guestRegisterFormHandler: GuestRegisterFormHandler;

    constructor(props: Props) {
        super(props);
        this.guestRegisterFormHandler = new GuestRegisterFormHandler(props);
        this.state = {
            registered: false,
            isCompany: false,
            isIndividual: true,
            isBrokerVM: false,
            //questions: [],
            brokers: [],
            dobMode: 'decade',
            showOTPModal: false,
            showResendBtn: false,
            disableResendBtn: false,
            otp: '',
            showResumeModal: false,
            isResumeMode: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateOTP = this.validateOTP.bind(this);
        this.resumeApplication = this.resumeApplication.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setOffering();
        this.getBrokers();
        this.props.form.setFieldsValue({ clientType: 1 });
    }

    setOffering() {
        const urlState = this.props?.location?.state as DetailsData | undefined;
        console.log(urlState);
        if (urlState?.id) {
            this.setState({ offeringId: urlState?.id });
            localStorage.setItem('offer', urlState?.id);
        }


        if (urlState?.alternateId) {
            this.setState({ sharepoolId: urlState?.alternateId });
            //localStorage.setItem('sharepool', urlState?.alternateId);
        }

        //let query = new URLSearchParams(this.props.location.search);

        //if (query.has('sp')) {
        //    var sharePoolId = query.get('sp');

        //    if (sharePoolId) {
        //        this.setState({ sharepoolId: sharePoolId });
        //    }
        //    //this.props.form.setFieldsValue({ sharePoolId: sharePoolId });
        //    //this.changeSharePool(sharePoolId);
        //}
    }

    //setSecurityQuestions() {
    //    var questions = [
    //        { text: 'What is the name of your childhood best friend?' },
    //        { text: 'What is the name of your manager at your first job?' },
    //        { text: 'Who is your favourite author?' },
    //        { text: 'What was the name of your first pet?' },
    //        { text: 'Where did you meet your spouse?' },
    //        { text: 'What is the name of the hospital in which you were born?' },
    //        { text: "What is your mother's middle name?" },
    //        { text: 'What was your favourite restaurant in college?' },
    //        { text: 'What was your favourite food as a child?' },
    //        { text: 'What is the name of your favourite book?' },
    //        { text: 'What is the first name of your favourite aunt?' },
    //        { text: 'What was your dream job as a child?' },
    //        { text: 'What was the name of your first school?' },
    //        { text: 'What is the first name of your oldest niece?' },
    //        { text: 'Where did you spend your honeymoon?' }
    //    ];
    //    this.setState({ questions: questions });
    //}

    onChange = e => {
        if (e.target.value == 1) {

        } else if (e.target.value == 2) {

        } else {

        }
        this.setState({
            isCompany: (e.target.value == 1 ? false : true),
            isIndividual: (e.target.value == 2 ? false : true),
        });
    };

    onBrokerChange = e => {

        this.setState({
            isBrokerVM: (e == "10" ? true : false),
        });
        //this.state.jointHolders.
    };

    handleCancel = e => {
        this.setState({
            showOTPModal: false,
            isResumeMode: false
        });
        //this.state.jointHolders.
    };

    closeResumeModal = e => {

        this.setState({
            showResumeModal: false,
            isResumeMode: false
        });
        //this.state.jointHolders.
    };

    reenableResendBtn() {
        this.setState({ disableResendBtn: false });
    }

    requestNewCode = e => {
        if (this.state.guestId) {
            this.guestRegisterFormHandler.ResendOTP(this.state.guestId).then(user => {
                this.setState({ disableResendBtn: true });
                setTimeout(() => this.reenableResendBtn(), 30000);
            });
        }
    }

    handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {


            if (!err) {

                //values.dateOfBirth = moment(values.dateOfBirth).format('YYYY-MM-DD');
                this.guestRegisterFormHandler.RequestRegister(values).then(user => {
                    if (user?.id) {
                        localStorage.setItem('guest', user?.id);
                        this.setState({ guestId: user?.id, showOTPModal: true });

                    }

                    //NotificationService.success(
                    //    'Successfully Registered',
                    //    <>
                    //        <p>
                    //            You have successfully registered your account. Please check your email address to activate your account.
                    //        </p>
                    //    </>, undefined, true
                    //);
                    // this.context.Update(user);
                    //this.setState({ registered: true });



                });
            }
        });
    }

    validateOTP() {
        console.log('validating');
        console.log(this.state.guestId);
        console.log(this.state.otp);
        if (this.state.guestId && this.state.otp) {
            //console.log('processing');
            this.guestRegisterFormHandler.ValidateOTP(this.state.guestId, this.state.otp).then(x => {
                //console.log('validated');
                this.context.Update(x);


                if (this.state.isResumeMode) {
                    this.props.history.push(
                        `/ipo/guest-apply/${this.state.offeringId}`,
                        new DetailsData(DetailsMode.Edit, this.state.offeringId, this.state.applicationId)
                    );
                } else {
                    //this.setState({ validate: true });
                    this.props.history.push(
                        this.state.sharepoolId ? `/ipo/guest-apply/${this.state.offeringId}?sp=${this.state.sharepoolId}` :
                            `/ipo/guest-apply/${this.state.offeringId}`,
                        new DetailsData(DetailsMode.New, this.state.offeringId, this.state.guestId)
                    );
                }
            }).catch(x => {
                //console.log('catched');
                this.setState({ showResendBtn: true });
            });
        }
    }

    resumeApplication() {
        if (this.state.resumeEmail && this.state.resumeId) {
            //console.log('processing');
            this.guestRegisterFormHandler.ResumeGuestApplication(this.state.resumeEmail, this.state.resumeId).then(x => {
                //console.log(x);
                this.setState({
                    guestId: x?.id, applicationId: x?.appId, offeringId: x?.offeringId,
                    isResumeMode: true, showOTPModal: true, showResumeModal: false
                });
                //this.setState({ validate: true });

            }).catch(x => {
                //console.log('catched');
                //this.setState({ showResendBtn: true });
            });
        }
    }

    getBrokers() {
        this.guestRegisterFormHandler.GetBrokers().then(x => {
            const brokers: ISelectOption[] =
                x.results?.map(y => ({
                    text: y.name,
                    value: y.id,
                })) ?? [];
            this.setState({ brokers });
        });
    }

    onPanelChange = (v, m) => {

        if (m != null) {
            this.setState({
                dobMode: m
            });
        } else {
            var newMode;
            switch (this.state.dobMode) {
                case 'date': newMode = 'date';
                    break;
                case 'decade': newMode = 'year';
                    break;
                case 'month': newMode = 'date';
                    break;
                case 'year': newMode = 'month';
                    break;
                default: newMode = null;
                    break;

            }

            this.setState({
                dobMode: newMode
            });
        }
    }

    onChangeOTP = e => {
        //console.log(e);
        //console.log(e.target.value);
        this.setState({ otp: e.target.value });
    };

    onPanelOpen = (v) => {

        this.setState({
            dobMode: 'decade'
        });

    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let state: { from?: any; noPermission?: boolean } = {};

        if (this.props.location) {
            state = this.props.location.state || {};
        }

        //if (this.state.validate) {
        //    return <Redirect to="/login"  />;
        //}

        return (
            <>
                <Modal
                    title=""
                    centered
                    visible={this.state.showOTPModal}
                    onOk={this.validateOTP}
                    onCancel={this.handleCancel}
                    footer={[
                        this.state.showResendBtn ?
                            <Button onClick={this.requestNewCode} disabled={this.state.disableResendBtn}>
                                Request New Code
                            </Button> : ''
                        ,
                        <Button key="back" onClick={this.handleCancel}>
                            Cancel
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.validateOTP} form="fiservForm" >
                            Submit
                        </Button>,
                    ]}
                >
                    <>

                        <p style={{ fontWeight: 'bolder' }} className="text-content-justified">
                            A One Time Code has been sent to your email. Please enter it below. Code will expire in 5 mins.    </p>


                        <FormControl getFieldDecorator={getFieldDecorator}
                            rules={[...ValidationUtility.required('OTP is required')]}
                            labelAlign={"left"}
                            labelCol={{ sm: { span: 24 } }} wrapperCol={{ sm: { span: 10 } }}
                            label={"One Time Password"} name="otp">
                            <Input onChange={this.onChangeOTP} />

                        </FormControl>

                    </>
                </Modal>
                <Modal
                    title=""
                    centered
                    visible={this.state.showResumeModal}
                    onOk={this.resumeApplication}
                    onCancel={this.closeResumeModal}
                    footer={[

                        <Button key="back" onClick={this.closeResumeModal}>
                            Cancel
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.resumeApplication} form="fiservForm" >
                            Submit
                        </Button>,
                    ]}
                >
                    <Row>

                        <p style={{ fontWeight: 'bolder' }} className="text-content-justified">
                            To resume your application please enter the application # and email.    </p>

                        <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>
                            <FormControl getFieldDecorator={getFieldDecorator}
                                rules={[...ValidationUtility.required('Application # is required')]}
                                labelAlign={"left"}
                                
                                label={"Application #"} name="resumeAppNum">
                                {/*<Input onChange={(e) => this.setState({ resumeId:  e.target.value }); } />*/}
                                <NumberFormat displayType={'input'} type={'text'} thousandSeparator={false} decimalScale={0} className={'ant-input'}
                                    onValueChange={(e) => this.setState({ resumeId: e.floatValue })}
                                />
                            </FormControl>
                        </Col>
                        <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>
                            <FormControl getFieldDecorator={getFieldDecorator}
                                rules={[...ValidationUtility.required('Email is required')]}
                                labelAlign={"left"}
                                
                                label={"Email"} name="resumeEmail">
                                <Input onChange={(e) => this.setState({ resumeEmail: e.target.value })} />

                            </FormControl>
                        </Col>
                    </Row>
                </Modal>

                <StyleGuestRegisterForm labelAlign={'left'} labelCol={{
                    xs: { span: 24 }, sm: { span: 24 }
                }}
                    wrapperCol={{
                        xs: { span: 24 }, sm: { span: 24 }
                    }}
                    autoComplete="off" layout="horizontal" onSubmit={this.handleSubmit}>


                    <Row type={'flex'} align={'bottom'}>
                        <Col xs={12} sm={12}>
                            <Title style={{ color: '#202020', fontWeight: 'bold' }} level={2}>Apply as Guest</Title>
                        </Col>
                        <Col xs={12} sm={12}>
                            <RightAlignedRow>
                                <Col>
                                    <Paragraph>Already have an account? <NavLink to={{ pathname: 'login' }} style={{ color: '#F0403D', fontWeight: 'normal' }}>SIGN IN</NavLink> </Paragraph>
                                </Col>
                            </RightAlignedRow>
                            <RightAlignedRow>
                                <Col>
                                    <Button type={'primary'} style={{ fontWeight: 500 }} onClick={() => this.setState({ showResumeModal: true, isResumeMode: true })} >
                                        RESUME APPLICATION </Button>
                                </Col>
                            </RightAlignedRow>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={{ span: 24 }}>
                            <Divider orientation="left"></Divider>
                            {/*<Row>*/}
                            {/*    <Col xs={{ span: 23, offset: 0 }} sm={{ span: 23, offset: 0 }}>*/}
                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            label="Client Type: "*/}

                            {/*            rules={[...ValidationUtility.required('Please select a client type!')]}*/}
                            {/*            name="clientType" //getFieldDecorator(name: { hidden: true })*/}
                            {/*        >*/}
                            {/*            <Radio.Group onChange={this.onChange}>*/}
                            {/*                <Radio value={1}>Individual</Radio>*/}
                            {/*                <Radio value={2}>Company</Radio>*/}
                            {/*            </Radio.Group>*/}
                            {/*        </FormControl>*/}

                            {/*    </Col>*/}
                            {/*</Row>*/}
                            {/*   <Form.Item
                                    label="Client Type">
                                    
                                    {getFieldDecorator("clientType", {
                                        rules: [{ required: true, message: "Please select a client type!" }]
                                    })(
                                        <Radio.Group onChange={this.onChange}>
                                            <Radio value={1}>Individual</Radio>
                                            <Radio value={2}>Company</Radio>
                                        </Radio.Group>
                                    )}
                                </Form.Item> */}


                            <div id="personalDiv" style={!this.state.isCompany ? {} : { display: 'none' }}>
                                <div className={styles.separator}>Personal Details</div>
                                <Row>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.required('First name is required')]}
                                            name="firstName" //getFieldDecorator(name: { hidden: true })
                                            label="First Name"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[]}
                                            name="middleInitial" //getFieldDecorator(name: { hidden: true })
                                            label="Middle Initial"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>
                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.required('Last name is required')]}
                                            name="lastName"
                                            label="Last Name"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.required('Tax Identification Number is required')]}
                                            name="trn"
                                            label="Tax Identification Number"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>

                                </Row>
                                <div className={styles.separator}>Contact Info</div>
                                <Row>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.required('Email is required')]}
                                            name="emailAddress"
                                            label="Email"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.required('Confirm email is required')]}
                                            name="confirmEmail"
                                            label="Confirm Email"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.If(!this.state.isCompany, ValidationUtility.required('Telephone is required'))]}
                                            name="telephone"
                                            label="Telephone"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row>
                                    {/*<Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>*/}
                                    {/*    <FormControl*/}
                                    {/*        getFieldDecorator={getFieldDecorator}*/}
                                    {/*        rules={[...ValidationUtility.If(!this.state.isCompany, ValidationUtility.required('Date of Birth is required'))]}*/}
                                    {/*        name="dateOfBirth"*/}
                                    {/*        label="Date of Birth"*/}
                                    {/*    >*/}

                                    {/*        <DatePicker mode={this.state.dobMode} onPanelChange={this.onPanelChange} onOpenChange={this.onPanelOpen} defaultPickerValue={moment("1999-01-01")} disabledDate={d => !d || d.isSameOrAfter(moment())} style={{ width: '100%' }}></DatePicker>*/}
                                    {/*    </FormControl>*/}
                                    {/*</Col>*/}
                                </Row>
                                {/* <div className={styles.separator}>Identification</div>*/}

                                <Row>
                                    {/*<Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>*/}
                                    {/*    <FormControl*/}
                                    {/*        getFieldDecorator={getFieldDecorator}*/}
                                    {/*        rules={[...ValidationUtility.If(!this.state.isCompany, ValidationUtility.required('Id Type is required'))]}*/}
                                    {/*        name="idType"*/}
                                    {/*        label="ID Type"*/}
                                    {/*    >*/}
                                    {/*        <Select allowClear={true}*/}
                                    {/*            placeholder={'Please select an option'}*/}
                                    {/*            optionFilterProp={'label'} >*/}
                                    {/*            <Option key={'Passport'} label={'Passport'} value={'Passport'}>*/}
                                    {/*                Passport*/}
                                    {/*            </Option>*/}
                                    {/*            <Option key={"Driver's License"} label={"Driver's License"} value={"Driver's License"}>*/}
                                    {/*                Driver's License*/}
                                    {/*            </Option>*/}
                                    {/*            <Option key={'National ID'} label={'National ID'} value={'National ID'}>*/}
                                    {/*                National ID*/}
                                    {/*            </Option>*/}
                                    {/*        </Select>*/}
                                    {/*    </FormControl>*/}
                                    {/*</Col>*/}

                                </Row>
                            </div>
                            <div id="companyDiv" style={this.state.isCompany ? {} : { display: 'none' }}>
                                <div className={styles.separator}>Company Details</div>
                                <Row>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.If(this.state.isCompany, ValidationUtility.required('Business name is required'))]}
                                            name="businessName"
                                            label="Business Name"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>
                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.If(this.state.isCompany, ValidationUtility.required('Contact First Name is required'))]}
                                            name="contactFirstName"
                                            label="Contact First Name"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>
                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.If(this.state.isCompany, ValidationUtility.required('Contact Last Name is required'))]}
                                            name="contactLastName"
                                            label="Contact Last Name"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>
                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.If(this.state.isCompany, ValidationUtility.required('Telephone is required'))]}
                                            name="contactTelephone"
                                            label="Contact Telephone"
                                        >
                                            <Input />
                                        </FormControl>
                                    </Col>
                                </Row>

                                <div className={styles.separator}>Identification</div>
                                <Row>
                                    <Col xs={{ span: 23, offset: 1 }}>

                                        <FormControl
                                            getFieldDecorator={getFieldDecorator}
                                            rules={[...ValidationUtility.If(this.state.isCompany, ValidationUtility.required('TRN is required'))]}
                                            name="trn"
                                            label="TRN"
                                        >
                                            <Input />
                                        </FormControl>

                                    </Col>
                                </Row>
                            </div>


                            <div className={styles.separator}>JCSD Account</div>
                            <Row>
                                <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                    <FormControl
                                        getFieldDecorator={getFieldDecorator}
                                        rules={[...ValidationUtility.required('JCSD Number is required')]}
                                        name="accountNumber"
                                        label="JCSD Number">
                                        <Input />
                                    </FormControl>
                                </Col>

                                <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>

                                    <FormControl
                                        getFieldDecorator={getFieldDecorator}
                                        rules={[...ValidationUtility.required('Broker is required'),]}
                                        name="brokerId"
                                        label="Broker">
                                        <SimpleSelect onChange={this.onBrokerChange}
                                            options={this.state.brokers}></SimpleSelect>
                                    </FormControl>
                                </Col>
                            </Row>
                            {/*<Row>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Password is required')]}*/}
                            {/*            name="password"*/}
                            {/*            label="Password"*/}
                            {/*        >*/}
                            {/*            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
                            {/*                type="password" />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11 }}>*/}
                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Confirm Password is required')]}*/}
                            {/*            name="confirmPassword"*/}
                            {/*            label="Confirm Password"*/}
                            {/*        >*/}
                            {/*            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}*/}
                            {/*                type="password" />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}

                            {/*<div className={styles.separator}>Security Questions</div>*/}
                            {/*<Row>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 13, offset: 1 }}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Security Question 1 is required')]}*/}
                            {/*            name="question1"*/}
                            {/*            label="Security Question 1"*/}
                            {/*        >*/}
                            {/*            <SimpleSelect options={this.state.questions} />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={9}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Answer 1 is required')]}*/}
                            {/*            name="answer1"*/}
                            {/*            label="Answer"*/}
                            {/*        >*/}
                            {/*            <Input />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                            {/*<Row>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 13, offset: 1 }}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Security Question 2 is required')]}*/}
                            {/*            name="question2"*/}
                            {/*            label="Security Question 2"*/}
                            {/*        >*/}
                            {/*            <SimpleSelect options={this.state.questions} />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={9}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Answer 2 is required')]}*/}
                            {/*            name="answer2"*/}
                            {/*            label="Answer"*/}
                            {/*        >*/}
                            {/*            <Input />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                            {/*<Row>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={{ span: 13, offset: 1 }}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Security Question 3 is required')]}*/}
                            {/*            name="question3"*/}
                            {/*            label="Security Question 3"*/}
                            {/*        >*/}
                            {/*            <SimpleSelect options={this.state.questions} />*/}

                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*    <Col xs={{ span: 23, offset: 1 }} sm={9}>*/}

                            {/*        <FormControl*/}
                            {/*            getFieldDecorator={getFieldDecorator}*/}
                            {/*            rules={[...ValidationUtility.required('Answer 3 is required')]}*/}
                            {/*            name="answer3"*/}
                            {/*            label="Answer"*/}
                            {/*        >*/}
                            {/*            <Input />*/}
                            {/*        </FormControl>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                        </Col>

                    </Row>

                    <Row>
                        <Col span={24}>
                            <FormControl
                                wrapperCol={{ xs: { offset: 1, span: 23 }, sm: { offset: 1, span: 20 } }}
                                getFieldDecorator={getFieldDecorator}
                                rules={[
                                    {
                                        required: true,
                                        transform: value => value || undefined,
                                        type: 'boolean',
                                        message: 'You must agree to the terms and conditions and the privacy policy.',
                                    },
                                ]}
                                label=""
                                name="agreement" //getFieldDecorator(name: { hidden: true })
                            >
                                <p className="text-content-justified">
                                    <Checkbox>
                                        I agree to the <a href={TcDoc} target="_blank" style={{ color: '#F0403D' }}>Terms and Conditions</a> and have read and understand the <a href={PrivacyDoc} target="_blank" style={{ color: '#F0403D' }}>Privacy Policy</a>
                                    </Checkbox>
                                </p>
                            </FormControl>


                        </Col>
                    </Row>
                    <Row>
                        <Col span={15}></Col>
                        <Col xs={{ span: 8, offset: 8 }} sm={{ span: 6, offset: 12 }} md={{ span: 4, offset: 16 }}>

                            <Button className="register-form-button" size="large" type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Col>
                        <Col xs={{ span: 8, offset: 0 }} sm={{ span: 6, offset: 0 }} md={{ span: 4, offset: 0 }}>
                            <NavLink to="/">
                                <Button className="cancel-form-button" size="large" ghost >Cancel</Button>
                            </NavLink>
                        </Col>
                    </Row>
                </StyleGuestRegisterForm>
            </>
        );
    }

    private ShouldRedirectTo(state: { from?: any; noPermission?: boolean | undefined }): boolean {
        return !!state.from && state.from.pathname !== '/logout';
    }
}

const GuestRegisterFormWithRouter = Form.create<Props>({
    name: 'GuestRegister',
})(GuestRegisterFormWithoutFormAndRouter);

const GuestRegisterForm = withRouter(GuestRegisterFormWithRouter);

export default GuestRegisterForm;



